/*
 * Generated on 6/21/2024, 12:04:06 PM
 * Do not edit this file, any changes will be overwritten
 */

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function openPopup(pUrl, pWidth, pHeight) {
  if (!pWidth) pWidth = 800;
  if (!pHeight) pHeight = 600;
  var sWidth = screen.availWidth;
  var sHeight = screen.availHeight;
  var pTop = sHeight / 2 - pHeight / 2;
  var pLeft = sWidth / 2 - pWidth / 2;
  window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' + ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}
function checkSidebarHeight() {
  $('.sidebar').each(function () {
    var sidebarHeight = $(this).outerHeight(true);
    var windowHeight = $(window).height();
    windowHeight -= $('.navbar-fixed-top').outerHeight();
    if (sidebarHeight > windowHeight) {
      $(this).addClass('no-affix');
    } else {
      $(this).removeClass('no-affix');
    }
  });
}
function printOnly($element) {
  $('body').addClass('print-nothing');
  $element.addClass('print');
  window.print();
  $element.removeClass('print');
  $('body').removeClass('print-nothing');
}
function isScrolledIntoView($element) {
  if ($element.length == 0 || !$element.is(':visible')) {
    return false;
  }
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $element.offset().top;
  var elemBottom = elemTop + $element.height();
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}
function getScrollbarWidth($element) {
  var remove = false;
  if (_typeof($element) == undefined) {
    remove = true;
    var $element = $('<div style="height:1px;overflow-y:scroll;"/>').appendTo('body');
  }
  var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
  if (remove) $element.remove();
  return scrollbarWidth;
}
function smoothScrollTo($element, offset) {
  if ($element.length === 0) return;
  $('html').get(0).scrollTo({
    top: $element.offset().top + (offset === undefined ? 0 : parseInt(offset)),
    behavior: 'auto'
  });
}
function smoothScrollToCenter($element, offset) {
  if ($element.length === 0) return;
  offset -= $(window).height() / 2;
  smoothScrollTo($element, offset);
}
function checkDateInputs() {
  $('.input-group-date').each(function () {
    if ($(this).data('date-inputs')) {
      return;
    }
    var $group = $(this);
    var $input = $group.siblings('input');
    var $inputDay = $group.find('.input-day');
    var $inputMonth = $group.find('.input-month');
    var $inputYear = $group.find('.input-year');
    $input.attr('type', 'text').addClass('d-none');
    $group.removeClass('d-none');
    var inputFocus = function inputFocus($field) {
      $field.trigger('focus');
      $field.attr('type', 'text');
      $field.get(0).setSelectionRange($field.val().length, $field.val().length);
      $field.attr('type', 'number');
    };
    $(this).find('input[type=number]').on('keydown', function (e) {
      ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault();
    }).on('input init', function (e) {
      var value = parseInt($(this).val());
      var min = $(this).attr('min') || false;
      var max = $(this).attr('max') || false;
      if (min !== false && value < min) $(this).val(min);
      if (max !== false && value > max) $(this).val(max);
      var entered = $inputYear.val() + '-' + $inputMonth.val() + '-' + $inputDay.val();
      if (entered === '--') entered = '';
      $input.val(entered).trigger(e.type);
    }).trigger('init');
    $group.on('focusout init', function (e) {
      if ($(e.relatedTarget).closest($group).length) {
        return;
      }
      if (e.type !== 'init') {
        $input.trigger('change');
      }
    }).trigger('init');
    $inputDay.on('keyup', function (e) {
      if ($(this).val().length === 2 && !isNaN(parseInt(e.key))) {
        inputFocus($inputMonth);
      }
    });
    $inputMonth.on('keyup', function (e) {
      if ($(this).val().length === 2 && !isNaN(parseInt(e.key))) {
        inputFocus($inputYear);
      }
    }).on('keydown', function (e) {
      if ($(this).val().length === 0 && e.keyCode === 8) {
        inputFocus($inputDay);
      }
    });
    $inputYear.on('keydown', function (e) {
      if ($(this).val().length === 0 && e.keyCode === 8) {
        inputFocus($inputMonth);
      }
    });
    $(this).data('date-inputs', true);
  });
}
var Menu = function () {
  var currentScrollTop = 0;
  $(document).ready(function () {
    var scrollBarWidth = getScrollbarWidth();
    $('.navbar-collapse').on('show.bs.collapse', function (e) {
      $('.navbar-toggle').addClass('active');
      $('body').addClass('scroll-disabled');
    });
    $('.navbar-collapse').on('hide.bs.collapse', function (e) {
      $('.navbar-toggle').removeClass('active');
      $('body').removeClass('scroll-disabled');
    });
    $('.navbar-main .has-submenu > a').on('click', function (e) {
      var $submenu = $(this).parent().find('.navbar-subnav');
      if (!$submenu.is(':visible') || $submenu.height() == 0) {
        e.preventDefault();
        $submenu.slideDown('fast');
        $(this).find('i').removeClass('fa-chevron-down');
        $(this).find('i').addClass('fa-chevron-up');
      }
    });
    $('.navbar-main .submenu-collapse').on('click', function (e) {
      var $submenu = $(this).parent().parent().parent().find('.navbar-subnav');
      if (!$submenu.is(':visible') || $submenu.height() > 0) {
        e.preventDefault();
        $submenu.slideUp('fast');
        $(this).find('i').removeClass('fa-chevron-up');
        $(this).find('i').addClass('fa-chevron-down');
      }
    });
    $('.open-navbar-search').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.navbar-search').addClass('focus').find('input').focus();
    });
    $(document).on('click', function () {
      $('.navbar-search').removeClass('focus');
    });
    $('.navbar-search').on('click', function (e) {
      e.stopPropagation();
    });
    $('a[data-target-popin-menu]').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if ($(this).hasClass('disabled')) {
        return;
      }
      var showContainer = $(this).data('target-popin-menu');
      $('.nav-popin-menu').not(showContainer).removeClass('active');
      if ($(showContainer).hasClass('active')) {
        $(showContainer).removeClass('active');
      } else {
        $(showContainer).addClass('active');
        $(window).trigger('resize-popin-menu');
      }
    });
    $(document).on('click', function (e) {
      $('.nav-popin-menu').removeClass('active');
    });
    $('.nav-popin-menu').on('click', function (e) {});
  });
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      $('.navbar-top .icon-button[data-toggle="collapse"].active').click();
    }
  });
  var setScrollTop = function setScrollTop() {
    currentScrollTop = window.scrollTop;
  };
  var getScrollbarWidth = function getScrollbarWidth() {
    var $div = $('<div />').css({
      width: '100px',
      height: '100px',
      overflow: 'scroll',
      position: 'absolute',
      top: '-9999px'
    }).appendTo($('body'));
    var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
    $div.remove();
    return scrollbarWidth;
  };
}();
$(function () {
  $('form').not('.novalidate').attr('novalidate', 'novalidate').each(function () {
    var $form = $(this);
    var $submit = $form.find('[type=submit]');
    var loadingMax = $(this).data('loading-max') || 5;
    var started = false;
    var getInputs = function getInputs() {
      return $form.find('select, input, textarea');
    };
    var formatDate = function formatDate(year, month, day) {
      if (("" + month).length === 1) month = '0' + month;
      if (("" + day).length === 1) day = '0' + day;
      var result = year + '-' + month + '-' + day;
      if (result === '--') result = '';
      return result;
    };
    var getAge = function getAge(year, month, day) {
      if (isNaN(Date.parse(formatDate(year, month, day)))) {
        return false;
      }
      year = parseInt(year);
      month = parseInt(month);
      day = parseInt(day);
      var today = new Date();
      var age = today.getFullYear() - year;
      if (today.getMonth() + 1 < month || today.getMonth() + 1 === month && today.getDate() < day) {
        age--;
      }
      if (age > 130 || age < 0) {
        return false;
      }
      return age;
    };
    var getError = function getError($field) {
      var $group = $field.closest('.form-group');
      var $error = $group.find('.input-error');
      if ($error.length === 0) {
        return $('<div>');
      }
      return $error;
    };
    var toggleError = function toggleError($field) {
      var $error = getError($field);
      var $group = $error.closest('.form-group');
      var errorType = $error.data('error-type') || '';
      var errorSettings = $error.data('error-default') || {};
      var errorMessage = errorSettings[errorType] || errorSettings['default'] || '';
      $error.html(errorMessage);
      if (errorType) {
        $field.data('had-error', true);
        showErrorElement($error);
      } else {
        $group.removeClass('form-error');
        $error.addClass('d-none').html('');
      }
    };
    var showErrorElement = function showErrorElement($error) {
      var $group = $error.closest('.form-group');
      if ($error.text().trim() !== '') {
        $error.removeClass('d-none');
      }
      $group.addClass('form-error');
    };
    var hideError = function hideError($field) {
      getError($field).data('error-type', '');
      toggleError($field);
    };
    var gotoFirstError = function gotoFirstError() {
      var $firstError = $form.find('.form-error');
      if ($firstError.length === 0) {
        return;
      }
      if ($form.closest('.modal').length > 0) {
        $form.closest('.modal').modal();
      } else {
        setTimeout(function () {
          smoothScrollToCenter($firstError, $firstError.outerHeight() / 2);
        }, 500);
      }
    };
    var checkServersideErrors = function checkServersideErrors() {
      var $allErrors = $form.find('.input-errors-all');
      $form.find('.input-error').each(function () {
        var field = $(this).attr('data-error-name');
        var $error = $allErrors.find('[data-error-name="' + field + '"]');
        if ($error.length > 0) {
          $error.remove();
          showErrorElement($(this));
        }
      });
      if ($allErrors.text().trim() === '') {
        $allErrors.hide();
      } else {
        $allErrors.slideDown('fast');
      }
      gotoFirstError();
    };
    var validateField = function validateField($field, e) {
      if ($field.data('validation') === 'none') return true;
      if (e.type === 'input' && !$field.data('had-error')) return true;
      var $group = $field.closest('.form-group');
      var $error = $group.find('.input-error');
      var name = $field.attr('name');
      var value = $field.val();
      var validateStr = $field.data('validate') || '';
      var validate = validateStr ? validateStr.split(',') : [];
      var type = $field.get(0).type;
      var errorType = '';
      if (!$group.is(':visible')) {
        hideError($error);
        return true;
      }
      if ($group.hasClass('form-required')) {
        validate.unshift('required');
      }
      validate.push(type);
      $.each(validate, function (key, validateItem) {
        var checkParts = validateItem.split(':');
        var check = checkParts[0];
        var args = checkParts[1];
        switch (check) {
          case 'required':
            switch (type) {
              default:
                if (value === '') {
                  errorType = 'required';
                  return false;
                }
                break;
              case 'checkbox':
              case 'radio':
                if (getInputs().filter('[name="' + name + '"]:checked').length === 0) {
                  errorType = 'required';
                  return false;
                }
            }
            break;
          case 'email':
            if (value === '') break;
            if (!/^.+@.+\..{2,}$/.test(value)) {
              errorType = 'email';
              return false;
            }
            break;
          case 'date':
            if (value === '') break;
            var dateParts = value.split('-');
            var date = new Date($field.val());
            var dateParsed = formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
            if (isNaN(date.getTime()) || dateParsed !== formatDate(dateParts[0], dateParts[1], dateParts[2]) || dateParts[0].length < 4) {
              errorType = 'date';
              return false;
            }
            break;
          case 'dob':
          case 'age':
            if (value === '') break;
            var dateParts = value.split('-');
            var age = getAge(dateParts[0], dateParts[1], dateParts[2]);
            if (age === false) {
              errorType = 'dob';
              return false;
            }
            if (check === 'age' && age < args) {
              errorType = 'age';
              return false;
            }
            break;
        }
      });
      $error.data('error-type', errorType);
      if (errorType) {
        $field.data('had-error', true);
        toggleError($field);
      } else {
        hideError($field);
      }
      return errorType === '';
    };
    $form.on('focus', 'select, input, textarea', function () {
      if (!started) {
        $form.trigger('start');
      }
      started = true;
    });
    $form.on('blur change input', 'select, input, textarea', function (e) {
      validateField($(this), e);
    });
    $form.not('.debug').on('submit fake-submit', function (e) {
      var hasErrors = false;
      var errorFields = [];
      getInputs().each(function () {
        if (!validateField($(this), e)) {
          errorFields.push($(this));
          hasErrors = true;
        }
      });
      $submit.prop('disabled', true);
      if (hasErrors) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $submit.removeClass('loading');
        setTimeout(function () {
          $submit.prop('disabled', false);
        }, 2000);
        gotoFirstError();
        $form.trigger('submit-fail', {
          fields: errorFields
        });
      } else {
        setTimeout(function () {
          $submit.prop('disabled', false);
        }, loadingMax * 1000);
        $form.trigger('submit-success');
      }
    });
    checkServersideErrors();
  });
});
$(function () {
  checkCustomInputs();
  checkDateInputs();
  $('[data-background], img[data-src]').imageLoader();
  $('a.popup').click(function (e) {
    e.preventDefault();
    openPopup($(this).attr('href'), $(this).data('popup-width'), $(this).data('popup-height'));
  });
  $(document).on('click', 'a.confirm', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $popin = $('.confirm-popin');
    var textYes = $(this).data('text-yes') || $popin.find('.yes').data('text-yes');
    var textNo = $(this).data('text-no') || $popin.find('.no').data('text-no');
    var onConfirm = $(this).data('onconfirm') || '';
    if ($popin.is(':visible')) {
      return;
    }
    $popin.find('.text').html($(this).data('confirm'));
    $popin.find('.yes').removeAttr('onclick').attr('href', $(this).attr('href')).text(textYes);
    $popin.find('.no').text(textNo);
    $popin.modal();
    if (onConfirm) {
      $popin.find('.yes').attr('onclick', onConfirm);
    }
  });
  $(document).on('click', 'a.show-alert', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $popin = $('.alert-popin');
    if ($popin.is(':visible')) {
      return;
    }
    $popin.find('.text').html($(this).data('alert'));
    $popin.modal();
  });
  $(document).on('keyup', 'input[type=number]', function () {
    var min = parseInt($(this).attr('min'));
    var max = parseInt($(this).attr('max'));
    var value = parseInt($(this).val());
    if (!isNaN(max) && value > max) {
      $(this).val(max);
    }
    if (!isNaN(min) && value < min) {
      $(this).val(min);
    }
  });
  $(document).on('mousedown', '.toggle-pass', function (e) {
    e.preventDefault();
    var $passField = $(this).parent().find('input');
    var $icon = $(this).find('i');
    var newType = $passField.attr('type') == 'text' ? 'password' : 'text';
    $passField.attr('type', newType).focus();
    newType == 'text' ? $icon.addClass('fa-eye-slash') : $icon.removeClass('fa-eye-slash');
  }).on('click', '.toggle-pass', function (e) {
    e.preventDefault();
  });
  $('.modal').on('show.bs.modal', function (e) {
    $('body').addClass('modal-active');
  }).on('hide.bs.modal', function (e) {
    $('body').removeClass('modal-active');
  });
  $(window).resize(function () {
    checkSidebarHeight();
  }).resize();
});
var dateTimePickerIcons = {
  time: 'fa fa-clock',
  date: 'fa fa-calendar',
  up: 'fa fa-chevron-up',
  down: 'fa fa-chevron-down',
  previous: 'fa fa-chevron-double-left',
  next: 'fa fa-chevron-double-right',
  today: 'fa fa-crosshairs',
  clear: 'fa fa-trash',
  close: 'fa fa-times'
};
$(window).on('mousewheel', function () {
  $(window).trigger('scroll');
});
setInterval(function () {
  $.get('/lib/keepalive.php');
}, 1000 * 60 * 10);